import { Button, Input, Space } from 'antd'
import TextArea from 'antd/es/input/TextArea'
import React from 'react'
import { Text } from '../../../../styles/reactnative'
import DeleteGroup from '../../DeleteGroup'
import SaveGroup from '../../SaveGroup'
import SendMessage from '../../SendMessage'
import ParentPartner from 'app/components/ParentPartner'
import GSlipageList from 'app/components/GSlipageList'

export const column_usergroup = mutate => {
	return [
		{
			title: '코드',
			dataIndex: 'id',
			align: 'center',
			key: 'name',
			render: (text, record) => {
				return <Text>{text}</Text>
			},
		},
		{
			title: '그룹순서',
			dataIndex: 'seq',
			align: 'center',
			key: 'seq',
			render: (text, record) => {
				return (
					<Input
						style={{
							verticalAlign: 'middle',
							fontSize: 11,
							width: 60,
						}}
						defaultValue={record?.seq}
						onChange={e => {
							record.seq = e.target.value
						}}
					/>
				)
			},
		},
		{
			title: '그룹명',
			dataIndex: 'name',
			align: 'center',
			key: 'name',
			render: (text, record) => {
				return (
					<Input
						style={{ verticalAlign: 'middle', fontSize: 11 }}
						defaultValue={record?.name}
						onChange={e => {
							record.name = e.target.value
						}}
					/>
				)
			},
		},
		{
			title: '그룹회원수',
			dataIndex: 'usercount',
			align: 'center',
			key: 'usercount',
			render: (text, record) => {
				return (
					<Button
						onClick={() => {
							window.location.href =
								'/users?groupid=' + record?.id
						}}>
						{text}
					</Button>
				)
			},
		},
		{
			title: '입금안내',
			dataIndex: 'info_d',
			align: 'center',
			key: 'infod',
			render: (text, record) => {
				if (record?.subgroup) return null
				return (
					<TextArea
						style={{ verticalAlign: 'middle', fontSize: 11 }}
						defaultValue={record?.info_d}
						onChange={e => {
							record.info_d = e.target.value
						}}
					/>
				)
			},
		},
		{
			title: '출금안내',
			dataIndex: 'info_w',
			align: 'center',
			key: 'infow',
			render: (text, record) => {
				if (record?.subgroup) return null
				return (
					<TextArea
						style={{ verticalAlign: 'middle', fontSize: 11 }}
						defaultValue={record?.info_w}
						onChange={e => {
							record.info_w = e.target.value
						}}
					/>
				)
			},
		},
		{
			title: '입금',
			dataIndex: 'kor_1',
			align: 'center',
			key: 'kor_1',
			render: (text, record) => {
				if (record?.subgroup) return null
				return (
					<Space.Compact style={{ maxWidth: 300 }}>
						<Input
							style={{
								verticalAlign: 'middle',
								fontSize: 11,
								width: 110,
							}}
							defaultValue={record?.kor_1}
							placeholder="은행명"
							onChange={e => {
								record.kor_1 = e.target.value
							}}
						/>
						<Input
							style={{ verticalAlign: 'middle', fontSize: 11 }}
							placeholder="계좌번호"
							defaultValue={record?.kor_2}
							onChange={e => {
								record.kor_2 = e.target.value
							}}
						/>
						<Input
							placeholder="예금주"
							style={{
								verticalAlign: 'middle',
								fontSize: 11,
								width: 120,
							}}
							defaultValue={record?.kor_3}
							onChange={e => {
								record.kor_3 = e.target.value
							}}
						/>
					</Space.Compact>
				)
			},
		},
		{
			title: '고객센터1',
			dataIndex: 'cs_1',
			align: 'center',
			key: 'cs1',
			render: (text, record) => {
				if (record?.subgroup) return null
				return (
					<Input
						style={{ verticalAlign: 'middle', fontSize: 11 }}
						defaultValue={record?.cs_1}
						onChange={e => {
							record.cs_1 = e.target.value
						}}
					/>
				)
			},
		},
		{
			title: '고객센터2',
			dataIndex: 'cs_2',
			align: 'center',
			key: 'cs2',
			render: (text, record) => {
				if (record?.subgroup) return null
				return (
					<Input
						style={{ verticalAlign: 'middle', fontSize: 11 }}
						defaultValue={record?.cs_2}
						onChange={e => {
							record.cs_2 = e.target.value
						}}
					/>
				)
			},
		},
		{
			title: '텔레상담링크',
			dataIndex: 'cs_3',
			align: 'center',
			key: 'cs3',
			render: (text, record) => {
				if (record?.subgroup) return null
				return (
					<Input
						style={{ verticalAlign: 'middle', fontSize: 11 }}
						defaultValue={record?.cs_3}
						onChange={e => {
							record.cs_3 = e.target.value
						}}
					/>
				)
			},
		},
		{
			title: '상담링크',
			dataIndex: 'cs_4',
			align: 'center',
			key: 'cs4',
			render: (text, record) => {
				if (record?.subgroup) return null
				return (
					<Input
						style={{ verticalAlign: 'middle', fontSize: 11 }}
						defaultValue={record?.cs_4}
						onChange={e => {
							record.cs_4 = e.target.value
						}}
					/>
				)
			},
		},
		{
			title: '상위파트너',
			dataIndex: 'parentid',
			align: 'center',
			key: 'parentid',
			render: (text, record) => {
				return <ParentPartner data={record} />
			},
		},
		{
			title: '슬리피지/노출',
			dataIndex: 'slippage',
			align: 'center',
			key: 'slippage',
			render: (text, record) => {
				return <GSlipageList group_id={record?.id} />
			},
		},
		{
			title: '관리',
			dataIndex: 'manage',
			key: 'manage',
			align: 'center',
			render: (text, data) => {
				return (
					<Space.Compact size="small">
						<SaveGroup data={data} mutate={mutate} />
						<DeleteGroup data={data} mutate={mutate} />
						<SendMessage target={'group'} targetid={data?.id} />
					</Space.Compact>
				)
			},
		},
	]
}
